<svg
  width="100%"
  height="100%"
  [attr.viewBox]="minimal() ? '0 0 100 100' : '0 0 320 100'"
  xmlns="http://www.w3.org/2000/svg"
>
  <defs>
    <style>
      @font-face {
        font-family: 'Noto Sans Georgian';
        font-style: normal;
        font-weight: 100 900;
        font-stretch: 62.5% 100%;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/notosansgeorgian/v44/PlIgFke5O6RzLfvNNVSitxkr76PRHBCSY_RHKPo.woff2)
          format('woff2');
      }
    </style>
  </defs>
  <text
    x="50%"
    y="50%"
    text-anchor="middle"
    dy="0.35em"
    font-size="50"
    font-weight="600"
    font-family="Roboto, sans-serif"
  >
    @if (!minimal()) {
    <tspan 
      baseline-shift="0.1em" style="fill: var(--mat-sys-on-surface)">{{ prefix() }}</tspan>
    }
    <tspan
      font-size="70"
      font-family="Noto Sans Georgian, sans-serif"
      baseline-shift="0.1em"
      style="fill: var(--mat-sys-primary)"
      >{{ accent() }}</tspan
    >
    @if (!minimal()) {
    <tspan 
      baseline-shift="0.1em" style="fill: var(--mat-sys-on-surface)">{{ suffix() }}</tspan>
    }
  </text>
</svg>
